import React from 'react';
import { Row, Tabs, Tab } from 'react-bootstrap';
import SearchEpcContainer from '../containers/SearchEpcContainer.jsx';
import SearchEpcCheckContainer from '../containers/SearchEpcCheckContainer.jsx';

export default class AdvancedSearchComponent extends React.Component {

  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    this.props.cleanSearchResult();
  }

  handleSelect(key) {
    this.props.changeEventKey(key);
    if (key === 0) {
    }
  }

  render() {
    return (
      <div>
        <h4>進階搜尋</h4>
        <Row>
          <Tabs id="editTab" defaultActiveKey={this.props.eventKey} animation={false} onSelect={this.handleSelect}>
            <Tab eventKey={0} title="晶片/洗標 搜尋">
              <SearchEpcContainer />
            </Tab>
            <Tab eventKey={1} title="晶片檢驗">
              <SearchEpcCheckContainer />
            </Tab>
          </Tabs>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/AdvancedSearchComponent.jsx